import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Modal } from 'react-bootstrap';
import useToken from 'hooks/useToken';


const PagosOrden = ({ idOrden }) => {
    const { token } = useToken();
    const [pago, setPago] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (idOrden) {
            fetchInformacionPago(idOrden);
        }
    }, [idOrden, token]);

    async function fetchInformacionPago(id) {
        try {
            const response = await fetch(`/api/contabilidad/facturas/FacturaOrden/ObtenerInformacionPago?idOrden=${encodeURIComponent(id)}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                const data = await response.json();
                const dataParsed = JSON.parse(data.data);
                if (data.iResponseType === 1) {
                    setPago(dataParsed.table1 || []);
                }
            }
        } catch (e) {
            console.log("Error al obtener info de pago: ", e);
        }
    }

    if (!idOrden || pago.length === 0) {
        return null; // Si no hay orden o no hay pagos, no mostramos el componente
    }

    return (
        <Card className="factura-card mb-1">
            <Card.Body className="factura-card-body d-flex flex-column flex-md-row justify-content-between align-items-center">
                <div className="mb-3 mb-md-0">
                    <h5 className="seccion-titulo mb-1" style={{ borderBottom: 'none', paddingBottom: 0 }}>
                        <i className="bi bi-credit-card-fill text-primary me-2"></i> Informaci&oacute;n de Pago | Admin Panel
                    </h5>
                    <p className="form-label-profesional text-muted mb-0" style={{ textTransform: 'none', letterSpacing: 'normal' }}>
                        Hay <strong>{pago.length}</strong> registro(s) de pago asociados a esta orden.
                    </p>
                </div>
                <Button
                    variant="info"
                    className="btn-sm"
                    onClick={() => setShowModal(true)}>
                    Mostrar Info de Pago
                </Button>

                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title className="seccion-titulo mb-0" style={{ borderBottom: 'none', paddingBottom: 0 }}>
                            Detalles de Pagos
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="bg-light p-3">
                        {pago.map((p, index) => (
                            <div key={index} className="factura-card mb-3 p-3 border-0 shadow-sm rounded bg-white">
                                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                                    <h6 className="seccion-titulo text-primary mb-0">
                                        <i className="bi bi-receipt me-2"></i>Pago #{index + 1}
                                    </h6>
                                    <span className="badge bg-light text-dark border" style={{ fontSize: '0.75rem' }}>
                                        {p.dFechaPago}
                                    </span>
                                </div>
                                <div className="row g-3">
                                    {/* Fila 1 */}
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Forma Pago</span>
                                        <span className="text-dark" style={{ fontSize: '0.85rem' }}>{p.vDescripcionFormaPago || p.idCatFormaPago}</span>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Medio Pago</span>
                                        <span className="text-dark" style={{ fontSize: '0.85rem' }}>{p.vMedioPago || p.idCatMedioPago}</span>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Cuenta Bancaria</span>
                                        <span className="text-dark" style={{ fontSize: '0.85rem' }}>{p.vNombreBanco ? `${p.vNombreBanco} - ${p.vAlias} (${p.vNumCta})` : p.idCatCuentaBancaria || 'N/A'}</span>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Moneda / TC</span>
                                        <span className="text-dark" style={{ fontSize: '0.85rem' }}>{p.vMoneda} {p.dTipoCambio > 1 ? `(TC: ${p.dTipoCambio})` : ''}</span>
                                    </div>

                                    {/* Fila 2 */}
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Saldo Anterior</span>
                                        <span className="text-dark" style={{ fontSize: '0.85rem' }}>{p.dSaldoAnterior}</span>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-primary d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Importe Pago</span>
                                        <span className="text-primary fw-bold" style={{ fontSize: '0.9rem' }}>{p.dImportePago}</span>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Saldo Insoluto</span>
                                        <span className="text-dark" style={{ fontSize: '0.85rem' }}>{p.dSaldoInsoluto}</span>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Parcialidad</span>
                                        <span className="text-dark" style={{ fontSize: '0.85rem' }}>{p.iNumeroParcialidad}</span>
                                    </div>

                                    {/* Fila 3 */}
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Usuario Registro</span>
                                        <span className="text-dark" style={{ fontSize: '0.85rem' }}>{p.vCreatedUser || 'N/A'}</span>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Comprobante</span>
                                        {p.vComprobante ? (
                                            <a href={p.vComprobante} target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-none" style={{ fontSize: '0.85rem' }}>
                                                <i className="bi bi-file-earmark-text me-1"></i>Ver Archivo
                                            </a>
                                        ) : (
                                            <span className="text-muted" style={{ fontSize: '0.85rem' }}>N/A</span>
                                        )}
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>ID Orden</span>
                                        <span className="text-dark" style={{ fontSize: '0.85rem' }}>{p.idOrden}</span>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <span className="text-muted d-block fw-bold text-uppercase" style={{ fontSize: '0.7rem' }}>Facturado</span>
                                        <span className={p.bIsFacturado ? "badge bg-success mt-1" : "badge bg-warning text-dark mt-1"} style={{ fontSize: '0.75rem' }}>
                                            {p.bIsFacturado ? 'Sí' : 'No'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>
            </Card.Body>
        </Card>
    );
};

PagosOrden.propTypes = {
    idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default PagosOrden;
